import { combineReducers } from '@reduxjs/toolkit'
import { reducer as formReducer } from 'redux-form'
import { xtrfInitialFilterState } from '../../config/xtrfInitialFilterState'
import { memsourceInitialFilterState } from '../../config/memsourceInitialFilterState'
import session from '../slices/session/session'
import languages from '../slices/languages/languages'
import specializations from '../slices/specializations/specializations'
import services from '../slices/services/services'
import projects from '../slices/projects/projects'
import page from '../slices/page/page'
import pageSize from '../slices/pageSize/pageSize'
import filters from '../slices/filters/filters'
import sort from '../slices/sort/sort'
import selectedProjects from '../slices/selectedProjects/selectedProjects'
import feedbackQuestions from '../slices/feedbackQuestions/feedbackQuestions'
import scroll from '../slices/scroll/scroll'
import notifier from '../slices/notifier/notifier'
import declineReasons from '../slices/declineReasons/declineReasons'
import currentProject from '../slices/currentProject/currentProject'
import { tempoInitialTerminologyFilterState, tempoInitialValidationFilterState } from '../../config/tempoConfig'
import collections from '../slices/collections/collections'
import items from '../slices/items/items'
import validators from '../slices/validators/validators'
import responsibles from '../slices/responsibes/responsibles'
import status from '../slices/status/status'
import columns from '../slices/columns/columns'
import jobs from '../slices/jobs/jobs'
import selectedJobs from '../slices/selectedJobs/selectedJobs'

const rootReducer = combineReducers({
    notifier,
    session,
    scroll,
    feedbackQuestions,
    form: formReducer,
    MEMSOURCE: combineReducers({
        filters: filters('MEMSOURCE', memsourceInitialFilterState),
        page: page('MEMSOURCE'),
        pageSize: pageSize('MEMSOURCE'),
        projects: projects('MEMSOURCE'),
        selectedProjects: selectedProjects('MEMSOURCE'),
        sort: sort('MEMSOURCE'),
        languages: languages('MEMSOURCE'),
        services: services('MEMSOURCE'),
        declineReasons: declineReasons('MEMSOURCE'),
        columns: columns('MEMSOURCE', 'PROJECTS'),
        columnsJobs: columns('MEMSOURCE', 'JOBS'),
        currentProject: currentProject('MEMSOURCE'),
        jobs: jobs('MEMSOURCE'),
        selectedJobs: selectedJobs('MEMSOURCE'),
    }),
    XTRF_PROJECTS: combineReducers({
        filters: filters('XTRF_PROJECTS', xtrfInitialFilterState),
        page: page('XTRF_PROJECTS'),
        pageSize: pageSize('XTRF_PROJECTS'),
        projects: projects('XTRF_PROJECTS'),
        selectedProjects: selectedProjects('XTRF_PROJECTS'),
        sort: sort('XTRF_PROJECTS'),
        languages: languages('XTRF_PROJECTS'),
        specializations: specializations('XTRF_PROJECTS'),
        services: services('XTRF_PROJECTS'),
        declineReasons: declineReasons('XTRF_PROJECTS'),
        columns: columns('XTRF_PROJECTS', 'PROJECTS'),
        columnsJobs: columns('XTRF_PROJECTS', 'JOBS'),
        currentProject: currentProject('XTRF_PROJECTS'),
    }),
    XTRF_QUOTES: combineReducers({
        filters: filters('XTRF_QUOTES', xtrfInitialFilterState),
        page: page('XTRF_QUOTES'),
        pageSize: pageSize('XTRF_QUOTES'),
        quotes: projects('XTRF_QUOTES'),
        selectedProjects: selectedProjects('XTRF_QUOTES'),
        sort: sort('XTRF_QUOTES'),
        languages: languages('XTRF_QUOTES'),
        specializations: specializations('XTRF_QUOTES'),
        services: services('XTRF_QUOTES'),
        declineReasons: declineReasons('XTRF_QUOTES'),
        columns: columns('XTRF_QUOTES', 'QUOTES'),
        columnsJobs: columns('XTRF_QUOTES', 'JOBS'),
        currentProject: currentProject('XTRF_QUOTES'),
    }),
    TEMPO: combineReducers({
        filters: filters('TEMPO', xtrfInitialFilterState),
        page: page('TEMPO'),
        pageSize: pageSize('TEMPO'),
        projects: projects('TEMPO'),
        quotes: projects('TEMPO'),
        selectedProjects: selectedProjects('TEMPO'),
        sort: sort('TEMPO'),
        languages: languages('TEMPO'),
        services: services('TEMPO'),
        declineReasons: declineReasons('TEMPO'),
        columns: columns('TEMPO', 'PROJECTS'),
        columnsJobs: columns('TEMPO', 'JOBS'),
        currentProject: currentProject('TEMPO'),
    }),
    TEMPO_QUOTES: combineReducers({
        filters: filters('TEMPO_QUOTES', xtrfInitialFilterState),
        page: page('TEMPO_QUOTES'),
        pageSize: page('TEMPO_QUOTES'),
        projects: projects('TEMPO_QUOTES'),
        selectedProjects: selectedProjects('TEMPO_QUOTES'),
        sort: sort('TEMPO_QUOTES'),
        languages: languages('TEMPO_QUOTES'),
        services: services('TEMPO_QUOTES'),
        currentProject: currentProject('TEMPO_QUOTES'),
        declineReasons: declineReasons('TEMPO_QUOTES'),
        columns: columns('TEMPO_QUOTES', 'QUOTES'),
        columnsJobs: columns('TEMPO_QUOTES', 'JOBS'),
    }),
    TEMPO_TERMINOLOGY: combineReducers({
        filters: filters('TEMPO_TERMINOLOGY', tempoInitialTerminologyFilterState),
        items: items('TEMPO_TERMINOLOGY'),
        page: page('TEMPO_TERMINOLOGY'),
        pageSize: page('TEMPO_TERMINOLOGY'),
        sort: sort('TEMPO_TERMINOLOGY'),
        languages: languages('TEMPO_TERMINOLOGY'),
        collections: collections('TEMPO_TERMINOLOGY'),
        columns: columns('TEMPO_TERMINOLOGY', ''),
        columnsJobs: columns('TEMPO_TERMINOLOGY', 'JOBS'),
    }),
    TEMPO_VALIDATION: combineReducers({
        filters: filters('TEMPO_VALIDATION', tempoInitialValidationFilterState),
        items: items('TEMPO_VALIDATION'),
        page: page('TEMPO_VALIDATION'),
        pageSize: page('TEMPO_VALIDATION'),
        sort: sort('TEMPO_VALIDATION'),
        validators: validators('TEMPO_VALIDATION'),
        responsibles: responsibles('TEMPO_VALIDATION'),
        status: status('TEMPO_VALIDATION'),
        languages: languages('TEMPO'),
        columns: columns('TEMPO_VALIDATION', ''),
        columnsJobs: columns('TEMPO_VALIDATION', 'JOBS'),
    }),
})

export default rootReducer
